export { default } from "./ResourcesList";
